import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menuItem", "collapseInput", "collapseContent"];

  connect() {
    this.highlightCurrentPage();
    this.expandActiveParent();
    this.setupAutoCollapse();
  }

  highlightCurrentPage() {
    const currentPath = window.location.pathname;

    this.menuItemTargets.forEach((item) => {
      const link = item.querySelector("a");
      if (link) {
        const linkPath = new URL(link.href).pathname;

        // 移除之前的active状态
        item.classList.remove("active");
        link.classList.remove("active");

        // 精确匹配或路径匹配
        if (this.isPathMatch(linkPath, currentPath)) {
          item.classList.add("active");
          link.classList.add("active");
        }
      }
    });
  }

  expandActiveParent() {
    // 找到当前激活的菜单项
    const activeItem = this.element.querySelector(".sidebar-menu-item.active");
    if (activeItem) {
      // 找到其父级的collapse容器
      const parentCollapse = activeItem.closest(".collapse");
      if (parentCollapse) {
        const input = parentCollapse.querySelector('input[type="checkbox"]');
        if (input) {
          input.checked = true;
          // 标记这个collapse应该保持打开状态
          parentCollapse.classList.add("keep-open");
        }
      }
    }
  }

  setupAutoCollapse() {
    // 为body添加class来启用自动折叠样式
    document.body.classList.add("sidebar-auto-collapse");
  }

  toggleCollapse(event) {
    const clickedCollapse = event.currentTarget.closest(".collapse");
    const clickedInput = clickedCollapse.querySelector(
      'input[type="checkbox"]'
    );

    // 如果当前要展开的菜单不包含活跃项，则关闭其他所有菜单
    if (clickedInput && !clickedInput.checked) {
      const activeItem = this.element.querySelector(
        ".sidebar-menu-item.active"
      );
      const hasActiveChild = activeItem && clickedCollapse.contains(activeItem);

      if (!hasActiveChild) {
        // 关闭所有其他菜单（除了包含活跃项的菜单）
        this.collapseInputTargets.forEach((input) => {
          if (input !== clickedInput) {
            const collapse = input.closest(".collapse");
            const hasActive =
              collapse && collapse.querySelector(".sidebar-menu-item.active");
            if (!hasActive) {
              input.checked = false;
              collapse.classList.remove("keep-open");
            }
          }
        });
      }
    }

    // 设置当前菜单的状态
    if (clickedInput.checked) {
      clickedCollapse.classList.add("keep-open");
    } else {
      clickedCollapse.classList.remove("keep-open");
    }
  }

  isPathMatch(linkPath, currentPath) {
    // 处理根路径
    if (linkPath === "/") {
      return currentPath === "/";
    }

    // 精确匹配
    if (linkPath === currentPath) {
      return true;
    }

    // 特殊路径匹配规则
    const pathMappings = {
      "/accounts/taobao_daren": ["/accounts/taobao_daren"],
      "/accounts/taobao_mcn": ["/accounts/taobao_mcn"],
      "/accounts/jingdong": ["/accounts/jingdong"],
      "/interfaces": ["/interfaces"],
      "/products": ["/products"],
      "/publishes": ["/publishes"],
      "/users": ["/users"],
    };

    // 检查特殊路径映射
    if (pathMappings[linkPath]) {
      return pathMappings[linkPath].some(
        (path) => currentPath === path || currentPath.startsWith(path + "/")
      );
    }

    // 检查是否是子路径（通用匹配）
    return currentPath.startsWith(linkPath + "/");
  }

  // 响应Turbo导航事件，重新高亮当前页面
  turboNavigate() {
    this.highlightCurrentPage();
    this.expandActiveParent();
  }
}

// 监听Turbo导航事件
document.addEventListener("turbo:load", () => {
  const sidebarController = document.querySelector(
    '[data-controller*="sidebar"]'
  );
  if (sidebarController && sidebarController.sidebarController) {
    sidebarController.sidebarController.turboNavigate();
  }
});
